import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/giovambattistafazioli/Lavori/Github/react-toggle/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { CodeSandbox } from "./theme/theme";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "get-started"
    }}>{`Get Started`}</h1>
    <h2 {...{
      "id": "requirements"
    }}>{`Requirements`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://nodejs.org"
        }}>{`node`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://yarnpkg.com/en/docs/install#mac-stable"
        }}>{`yarn`}</a></li>
    </ul>
    <h2 {...{
      "id": "installation"
    }}>{`Installation`}</h2>
    <p>{`You can use either `}<strong parentName="p">{`npm`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm i react-toggle-component
`}</code></pre>
    <p>{`or `}<strong parentName="p">{`yarn`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`yarn add react-toggle-component
`}</code></pre>
    <h2 {...{
      "id": "code-sandbox"
    }}>{`Code Sandbox`}</h2>
    <CodeSandbox id="01nxypo6zl" mdxType="CodeSandbox" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      